import { handleErrors } from "./utils";

export const getMoreProductsAPI = async (categorySlug, searchUrl) => {
  const url = `${process.env.INVENTORY_SERVICE_API_URL}/api/rest/v5/products/jewellery/${categorySlug}/?${searchUrl}`;
  try {
    const res = await fetch(url, { cache: "no-store" });
    const data = await res.json();
    return data.products;
  } catch (error) {
    handleErrors(error);
  }
}


export const applyFiltersAPI = async (categorySlug, searchUrl) => {
  const url = `${process.env.INVENTORY_SERVICE_API_URL}/api/rest/v5/products/jewellery/${categorySlug}/?${
    searchUrl.length > 0  ? searchUrl + "&attribute_only=true" : "attribute_only=true"
  }`;
  try {
    const res = await fetch(url, { cache: "no-store" });
    const data = await res.json();
    return data;
  } catch (error) {
    handleErrors(error);
  }
}

